import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { lighten, makeStyles } from '@material-ui/core/styles';
import cn from 'classnames';
import { colors } from '../../constants/styleConstants';

const useStyles = makeStyles(theme => ({
  root: {
    padding: 4,
    backgroundColor: colors.fieldsBorderGray,
    color: colors.black,
    borderRadius: 4,
    lineHeight: 1,
    fontWeight: 'bold',
    marginRight: theme.spacing(1),
  },
  green: {
    backgroundColor: lighten(colors.greenChip, 0.3),
    color: colors.white,
  },
  yellow: {
    backgroundColor: lighten(colors.yellow, 0.3),
    color: colors.white,
  },
  red: {
    backgroundColor: lighten(colors.redCancel, 0.3),
    color: colors.white,
  },
}));

const StatusLabel = ({ status, children }) => {
  const classes = useStyles();

  return <span className={cn(classes.root, classes[status])}>{children}</span>;
};

StatusLabel.propTypes = {
  status: PropTypes.oneOf(['green', 'yellow', 'red', '']),
  children: PropTypes.string.isRequired,
};

StatusLabel.defaultProps = {
  status: '',
};

export default memo(StatusLabel);
